import { getMinnedMaxedValue } from '@hooks/useForm/utils';

export const useOnNumberStringBlur = (min?: number, max?: number) => (event: React.FocusEvent<HTMLInputElement>) => {
  event.target.value = String(getMinnedMaxedValue(event.target.value, min, max)).replace(`.`, `,`);
};

export type OnBlurType = ReturnType<typeof useOnNumberStringBlur>;
